"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActensoPanelTokenErrorV1 = exports.ActensoPanelTokenErrorCode = exports.ActensoPanelTokenV1 = void 0;
const zod_1 = require("zod");
// ── REST панели ИИ-ассистента Actenso (эпик ACTPANEL, O6) ──
//
// `POST /api/v1/assistant/panel-token` — не NATS-маршрут: ключ панели организации на шину не
// выходит. Схемы общие для core-node и UI, чтобы причины отказа различались по коду, а не по тексту.
/** Успешный ответ: panel-JWT и момент его истечения (ISO-8601). */
exports.ActensoPanelTokenV1 = zod_1.z.object({
    token: zod_1.z.string().min(1),
    expiresAt: zod_1.z.string().datetime({ offset: true }),
});
/**
 * Причина отказа. 403: `tenant_inactive` — организации нет или она выключена (JWT ещё не истёк),
 * `not_a_user` — актор без строки в core.users (сервисный/dev-токен),
 * `inactive` — пользователь выключен, `no_role_code` — ни одной роли с правом `assistant:use` и
 * кодом роли Actenso, `ambiguous_role_code` — у таких ролей разные коды. 503: `not_configured` —
 * у тенанта нет ключа панели, `exchange_failed` — Actenso ответил ошибкой или не ответил.
 */
exports.ActensoPanelTokenErrorCode = zod_1.z.enum([
    'tenant_inactive',
    'not_a_user',
    'inactive',
    'no_role_code',
    'ambiguous_role_code',
    'not_configured',
    'exchange_failed',
]);
/** Тело отказа: текст для человека и код для логики UI. */
exports.ActensoPanelTokenErrorV1 = zod_1.z.object({
    message: zod_1.z.string(),
    code: exports.ActensoPanelTokenErrorCode,
});
//# sourceMappingURL=assistant.js.map